<template>
  <div>
    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      summary
      :summary-method="summaryMethod"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
      :cell-style="cellStyle"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="toDetail(scope.data, scope.$index)"
          >明细</el-button
        >
        <el-button
          class="button"
          v-hasPermi="[authIdentity + ':print']"
          @click="handlePrint(scope.data, scope.$index)"
          type="text"
          size="small"
          >打印</el-button
        >
        <!-- <el-dropdown style="margin-left:10px">
            <i class="el-icon-more"></i>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(dropdown, index) in operateMore"
                :disabled="fundisabled(dropdown, scope.data)"
                @click.native="dropdown.click(scope.data)"
                :key="index"
                :icon="'el-icon-ht-'+dropdown.auth"
              >{{ dropdown.label }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>-->
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView"></component>
    </Mdialog>

    <el-dialog
      title="打印预览"
      class="dialog"
      :visible.sync="printInfo.printDialog"
      :close-on-click-modal="false"
      width="60%"
      @close="printInfo.printDialog = false"
      destroy-on-close
      append-to-body
      :top="'5vh'"
    >
      <PrintBox ref="printBox" v-if="printInfo.printDialog" />
    </el-dialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import PrintBox from '@/components/PrintBox'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/procure/plan/components/form'

import { getDropPlantationList } from '@/api/manage/plantation'
import { getInspectionSheetItemQueryList } from '@/api/manage/inspection-sheet-item'
import { selectEarliestInspectionTime } from '@/api/manage/inspection-sheet'
import { getFairValue } from '@/api/manage/universal-fair-value'

import { isDef } from '@/utils/is'
export default {
  name: 'Receipt',
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
    PrintBox,
  },
  data() {
    const _this = this
    return {
      authIdentity: 'pick:warehouse',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'pickingBatchBizNo',
          label: '采摘批次',
          isTrue: true,
        },
        {
          prop: 'pickingDateTime',
          label: '采摘日期',
          isTrue: true,
          formatter(row) {
            return row.pickingDateTime ? _this.parseTime(row.pickingDateTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'cropBrandKeyValue',
          label: '产品名称',
          isTrue: true,
          width: '100',
        },
        {
          prop: '',
          label: '规格',
          isTrue: true,
          width: '100',
          align: 'left',
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              row.cultivationMethodSpecValueKey,
            ]
            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: '',
          label: '果园过磅',
          isTrue: true,
          children: [
            {
              prop: 'totalQuantity',
              label: '满筐总筐数',
              isTrue: true,
              width: '100',
            },

            {
              prop: 'totalNetWeight',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
            },
          ],
        },
        {
          prop: '',
          label: '工厂核验',
          isTrue: true,
          children: [
            {
              prop: 'totalApprovedQuantity',
              label: '满筐总筐数',
              isTrue: true,
              width: '100',
            },
            {
              prop: 'totalApprovedNetWeight',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
            },
          ],
        },
        {
          prop: '',
          label: '不达标',
          isTrue: true,
          children: [
            {
              prop: '',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
              formatter(row) {
                return row.notStandardNetWeight
              },
            },
          ],
        },
        {
          prop: '',
          label: '结算数量',
          isTrue: true,
          children: [
            {
              prop: 'totalSettlementNetWeight',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
            },
          ],
        },
        {
          prop: '',
          label: '监园人员',
          isTrue: true,
          width: '90',
          formatter(row) {
            return JSON.parse(row.supervisorIdList || '[]')
              .map((item) => item.userName)
              .join(',')
          },
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'inspectionYear',
          placeholder: '请选择验收年份',
          value: 'id',
          label: 'inspectionYear',
          list: [],
          type: 'year',
        },
        {
          model: 'pickingBatchBizNo',
          placeholder: '请输入批次',
          class: 'home',
          type: 'input',
        },
      ],

      printInfo: {
        printDialog: false,
        type: 'receipt',
        list: [],
      },

      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },

      fairValue: {},
    }
  },
  async mounted() {
    this.getPlantationList()
    await this.getFairValue()
    this.getList()
  },
  methods: {
    async getFairValue() {
      const data = await getFairValue({ name: '验收差值' })

      if (data.code === 200) {
        const { maxFairValue, minFairValue } = data.data || {}
        this.fairValue = {
          maxFairValue,
          minFairValue,
        }
      }
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getInspectionSheetItemQueryList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getPlantationList() {
      getDropPlantationList().then((res) => {
        this.selectOrInputList[0].list = res.data.map((item) => {
          item.name = `${item.bizNo}-${item.name}`
          return item
        })
      })
    },
    summaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 6) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalQuantity || 0), 2)
          }, 0)
          return
        }
        if (index == 7) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 8) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalApprovedQuantity || 0), 2)
          }, 0)
          return
        }
        if (index == 9) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalApprovedNetWeight || 0), 2)
          }, 0)
          return
        }

        if (index == 10) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.notStandardNetWeight || 0), 2)
          }, 0)
          return
        }

        if (index == 11) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      const { maxFairValue, minFairValue } = this.fairValue

      const weightRate = this.myFixed(row.totalVarianceNetWeight / row.totalNetWeight * 100, 2)
      if (
        isDef(maxFairValue) &&
        isDef(minFairValue) &&
        (weightRate > maxFairValue || weightRate < minFairValue) &&
        [6, 7, 8, 9, 10, 11].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      }

    },
    toDetail(row) {
      this.$router.push(
        `/receiptDetail?pickingBatchId=${row.pickingBatchId}&pickingBatchBizNo=${row.pickingBatchBizNo}`
      )
    },
    async handlePrint(row) {
      row.showShippingOrderBizNo = false

      const data = await selectEarliestInspectionTime({ pickingBatchIds: row.pickingBatchId })
      if (data.code !== 200) return
      
      this.printInfo.list = [{ ...row, traceabilityNodeTime: data.data?.[0]?.traceabilityNodeTime }]

      this.printInfo.printDialog = true
      this.$nextTick(() => {
        this.$refs.printBox.init(this.printInfo)
      })
    },
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'myform'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
</style>
